import { render, staticRenderFns } from "./CustomerGroupList.vue?vue&type=template&id=729552d9&scoped=true"
import script from "./CustomerGroupList.vue?vue&type=script&lang=js"
export * from "./CustomerGroupList.vue?vue&type=script&lang=js"
import style0 from "./CustomerGroupList.vue?vue&type=style&index=0&id=729552d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729552d9",
  null
  
)

export default component.exports